import { uploadFile } from '../../services/api/file';
import { fetchFileTypes } from '../../services/api/common';

const REQUEST_PASSPORT_OGRN_VALUE = 'COPYID';
const PROFILE_CONTRACT_VALUE = 'PROFILECONTRACT';
const PROFILE_OGRN_VALUE = 'PROFILEOGRN';
const PROFILE_CONSENT_VALUE = 'COPYOFCONSENTSTATEMENT';
const ATTORNEY_VALUE = 'COPYATTORNEY';

export const fileUploader = {
    namespaced: true,
    state: {
        fileTypes: [],
    },
    mutations: {
        save(state, data) {
            state.fileTypes = data;
        }
    },
    actions: {
        fetchFileTypes({ commit, dispatch }) {
            return fetchFileTypes()
                .then((res) => {
                    commit('save', res.data);
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    throw res;
                });
        },
        upload({ dispatch }, { files, fileType }) {
            return uploadFile(files, { fileType })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    throw res;
                });
        },

        uploadProfileOgrn({ dispatch, getters }, files) {
            return dispatch('upload', { files, fileType: getters.profileOgrnId });
        },
        uploadProfileContract({ dispatch, getters }, files) {
            return dispatch('upload', { files, fileType: getters.profileContractId });
        },
        uploadProfileConsent({ dispatch, getters }, files) {
            return dispatch('upload', { files, fileType: getters.profileConsentId });
        },
        uploadRequestPassportOgrn({ commit, dispatch, getters }, files) {
            return dispatch('upload', { files, fileType: getters.requestPassportOgrnId });
        },
        uploadAttorney({ commit, dispatch, getters }, files) {
            return dispatch('upload', { files, fileType: getters.attorneyId });
        }
    },
    getters: {
        fileTypes({ fileTypes }) {
            return fileTypes
        },
        isFetched({ fileTypes }) {
            return fileTypes.length > 0;
        },
        fileTypesObject({ fileTypes }) {
            return fileTypes.reduce((types, type) => {
                types[type.value.trim().toUpperCase()] = type.id;
                return types;
            }, {});
        },
        profileOgrnId(state, { fileTypesObject }) {
            return fileTypesObject[PROFILE_OGRN_VALUE];
        },
        profileContractId(state, { fileTypesObject }) {
            return fileTypesObject[PROFILE_CONTRACT_VALUE];
        },
        profileConsentId(state, { fileTypesObject }) {
            return fileTypesObject[PROFILE_CONSENT_VALUE];
        },
        requestPassportOgrnId(state, { fileTypesObject }) {
            return fileTypesObject[REQUEST_PASSPORT_OGRN_VALUE];
        },
        attorneyId(state, { fileTypesObject }) {
            return fileTypesObject[ATTORNEY_VALUE];
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/fileUploader/store.js